import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import {
    fetchSignupRequirements,
    fetchSignupRequirementsReset,
} from '@perpay-web/components/actions/signupRequirements';
import {
    createPasswordSuccess,
    completeSignupRequirements,
} from '@perpay-web/fintech/actions/entities/partnerOnboarding';
import { STORE_VERIFY_PHONE_SUCCESS } from '@perpay-web/fintech/constants/actionTypes';

export const invalidateSignupRequirementsCacheOnPasswordCreated = (action$) =>
    action$.pipe(
        ofType(createPasswordSuccess().type),
        mergeMap(() => [
            fetchSignupRequirementsReset(),
            fetchSignupRequirements(),
        ]),
    );

export const invalidateSignupRequirementsCacheOnPhoneVerified = (action$) =>
    action$.pipe(
        ofType(STORE_VERIFY_PHONE_SUCCESS),
        mergeMap(() => [
            fetchSignupRequirementsReset(),
            fetchSignupRequirements(),
        ]),
    );

export const invalidateSignupRequirementsCacheOnComplete = (action$) =>
    action$.pipe(
        ofType(completeSignupRequirements().type),
        mergeMap(() => [
            fetchSignupRequirementsReset(),
            fetchSignupRequirements(),
        ]),
    );
